import HeroSection from "../components/Common/HeroSection";
import BannerSection from "../components/Common/PlatformBannerSection";
import HealthCapabilities from "../components/DigitalHealth/HealthCapabilities";
import DigitalHealthSection from "../components/DigitalHealth/WhatDigitalHealth";
import WhyChooseDigitalHealth from "../components/DigitalHealth/WhyChoose";
import DigitalHealthPlatforms from "../components/DigitalHealth/HealthPlatformSection";
import LandingHero from "../components/Common/LandingHero";
import data from "../content.json";

const DigitalHealth = () => {
  const heroButtons = [
    {
      label: "Explore Our Solutions",
      className: "btn-secondary",
      onClick: () => console.log("Explore Our Solutions clicked"),
    },
    {
      label: "Talk to a Digital Health Expert",
      className: "btn-outline",
      onClick: () => console.log("Talk to Helath expert"),
    },
  ];

  const stakeholders = [
    {
      image: "/assets/digitalHealth/3section-1.svg",
      title: " Digital Health Platforms",
      description:
        "Scalable platforms to manage healthcare data, workflows, and system integrations with ease.",
    },
    {
      image: "/assets/digitalHealth/3section-2.svg",
      title: " Remote Care & Monitoring",
      description:
        "Enabling virtual care, continuous monitoring, and real-time patient engagement beyond traditional settings.",
    },
    {
      image: "/assets/digitalHealth/3section-3.svg",
      title: " Clinical Data Management",
      description:
        "Unified and interoperable systems for accurate, accessible, and actionable clinical data.",
    },
    {
      image: "/assets/digitalHealth/3section-4.svg",
      title: "Patient Engagement Solutions",
      description:
        "Personalized digital experiences that improve communication, access, and care continuity.",
    },
  ];

  const platforms = [
    {
      image: "/assets/digitalHealth/4section-1.svg",
      title: "Women's Health Platform",
      description:
        "An intelligent, personalized, and connected digital health platform designed to support women from adolescence to menopause—and beyond.​",
    },
    {
      image: "/assets/digitalHealth/4section-2.svg",
      title: "Child Health Platform",
      description:
        "An AI-powered Digital Child Health Platform that supports children’s growth, development, and wellbeing through continuous monitoring, and seamless access to pediatric care.​",
    },
    {
      image: "/assets/digitalHealth/4section-3.svg",
      title: "Behavioral Health Platform​",
      description:
        "An AI-powered Digital Child Health Platform that supports children’s growth, development, and wellbeing through continuous monitoring, and seamless access to pediatric care.​",
    },
    {
      image: "/assets/digitalHealth/4section-4.svg",
      title: "Health Concierge Platform",
      description:
        "An intelligent, personalized, and connected digital health platform designed to support women from adolescence to menopause—and beyond.​",
    },
    {
      image: "/assets/digitalHealth/4section-5.svg",
      title: "Second Opinion Platform",
      description:
        "A digital second-opinion platform connecting patients to top specialists, advanced diagnostics, and AI-assisted clinical reviews for accurate diagnoses and informed treatment decisions.",
    },
  ];

  return (
    <>
      <div className="relative z-20 overflow-visible">
        <LandingHero data={data.digitalHealth.hero} />
      </div>
      <div className="pt-4 md:pt-10">
        {/* <HeroSection
        backgroundImage='/assets/digitalHealth/hero.svg'
        title="Digital Health Solutions for Smarter, Connected Care"
        subtitle="Empowering healthcare providers with secure, scalable, and data-driven digital health platforms that improve care delivery and patient outcomes."
        buttons={heroButtons}
        textAlign="center"
        height="h-screen"
      /> */}

        <DigitalHealthSection
          description="Digital Health solutions use advanced technology, intelligent platforms, and real-time data to modernize healthcare systems. By enabling connected care, seamless data exchange, and secure digital experiences, Digital Health empowers providers to deliver better outcomes, improves patient engagement, and enhances operational efficiency across the entire care journey."
          image="/assets/digitalHealth/2section.svg"
        />

        <HealthCapabilities stakeholders={stakeholders} />

        <DigitalHealthPlatforms platforms={platforms} />

        <WhyChooseDigitalHealth />
        <BannerSection
          title="Ready to Build the Future of"
          highlightedText="Digital Health?"
          description="Partner with Avexa to create secure, intelligent, and scalable digital health solutions that drive better outcomes."
          buttonText="Get In Touch"
          buttonLink="/get-in-touch"
          backgroundColor="var(--primary-color)"
          variant="dark"
        />
        <div className="h-8 md:h-12 lg:h-16 bg-white"></div>
      </div>
    </>
  );
};

export default DigitalHealth;
